import {
  LIST_ADDITIONAL_SERVICE_REQUEST,
  LIST_ADDITIONAL_SERVICE_SUCCESS,
  LIST_ADDITIONAL_SERVICE_FAIL,
  LIST_ADDITIONAL_SERVICE_SUMMARY_REQUEST,
  LIST_ADDITIONAL_SERVICE_SUMMARY_SUCCESS,
  LIST_ADDITIONAL_SERVICE_SUMMARY_FAIL,
  SELECT_SERVICE_ADDITIONAL_SERVICE_REQUEST,
  SELECT_SERVICE_ADDITIONAL_SERVICE_SUCCESS,
  SELECT_SERVICE_ADDITIONAL_SERVICE_FAIL,
  SET_PRICE_ADDITIONAL_SERVICE_REQUEST,
  SET_PRICE_ADDITIONAL_SERVICE_SUCCESS,
  SET_PRICE_ADDITIONAL_SERVICE_FAIL,
  DELETE_ADDITIONAL_SERVICE_REQUEST,
  DELETE_ADDITIONAL_SERVICE_SUCCESS,
  DELETE_ADDITIONAL_SERVICE_FAIL,
  RESET_ADDITIONAL_SERVICE,
  GET_ADDITIONAL_SERVICE_REQUEST,
  GET_ADDITIONAL_SERVICE_SUCCESS,
  GET_ADDITIONAL_SERVICE_FAIL,
  GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_REQUEST,
  GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_SUCCESS,
  GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_FAIL,
  LIST_PARTNER_ADDITIONAL_SERVICE_REQUEST,
  LIST_PARTNER_ADDITIONAL_SERVICE_SUCCESS,
  LIST_PARTNER_ADDITIONAL_SERVICE_FAIL,
  GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_REQUEST,
  GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_SUCCESS,
  GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_FAIL
} from '../../constants/additional-services'

const initialState = {
  loading: false,
  loadingSupportingDocs: false,
  additionalServices: [],
  additionalServiceItems: [],
  additionalServiceSupportingDocs: [],
  additionalService: {},
  additionalServicesSummary: [],
  additionalServiceSummary: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const additionalServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_ADDITIONAL_SERVICE_REQUEST:
      return { ...state, loading: true, additionalServices: [] }
    case LIST_ADDITIONAL_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        additionalServices: action.payload,
        pageable: action.pageable
      }
    case LIST_ADDITIONAL_SERVICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        additionalServices: action?.dummy
      }
    case LIST_ADDITIONAL_SERVICE_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_ADDITIONAL_SERVICE_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        additionalServicesSummary: action.payload
      }
    case LIST_ADDITIONAL_SERVICE_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case SELECT_SERVICE_ADDITIONAL_SERVICE_REQUEST:
      return { ...state, loadingCreate: true }
    case SELECT_SERVICE_ADDITIONAL_SERVICE_SUCCESS:
      return { ...state, loadingCreate: false }
    case SELECT_SERVICE_ADDITIONAL_SERVICE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case SET_PRICE_ADDITIONAL_SERVICE_REQUEST:
      return { ...state, loadingUpdate: true }
    case SET_PRICE_ADDITIONAL_SERVICE_SUCCESS:
      return { ...state, loadingUpdate: false }
    case SET_PRICE_ADDITIONAL_SERVICE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case GET_ADDITIONAL_SERVICE_REQUEST:
      return { ...state, loadingDetail: true }
    case GET_ADDITIONAL_SERVICE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        additionalServiceItems: action.payload
      }
    case GET_ADDITIONAL_SERVICE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        additionalServiceItems: action?.dummy,
        error: action.payload
      }
    case GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_REQUEST:
      return { ...state, loadingDetail: true }
    case GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        additionalServiceItems: action.payload
      }
    case GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_FAIL:
      return {
        ...state,
        loadingDetail: false,
        additionalServiceItems: action?.dummy,
        error: action.payload
      }
    case DELETE_ADDITIONAL_SERVICE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_ADDITIONAL_SERVICE_SUCCESS:
      const additionalServiceId = action.payload
      const indexServiceCategory = state.additionalServices.findIndex(
        (additionalService) => additionalService.id === additionalServiceId
      )
      state.additionalServices.splice(indexServiceCategory, 1)

      return {
        ...state,
        loadingDelete: false,
        additionalServices: state.additionalServices
      }
    case DELETE_ADDITIONAL_SERVICE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_ADDITIONAL_SERVICE:
      return initialState
    case LIST_PARTNER_ADDITIONAL_SERVICE_REQUEST:
      return { ...state, loading: true, additionalServices: [] }
    case LIST_PARTNER_ADDITIONAL_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        additionalServices: action.payload,
        pageable: action.pageable
      }
    case LIST_PARTNER_ADDITIONAL_SERVICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        additionalServices: action?.dummy
      }
    case GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_REQUEST:
      return { ...state, loadingSupportingDocs: true }
    case GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_SUCCESS:
      return {
        ...state,
        loadingSupportingDocs: false,
        additionalServiceSupportingDocs: action.payload
      }
    case GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_FAIL:
      return {
        ...state,
        loadingSupportingDocs: false,
        error: action.payload,
        additionalServiceSupportingDocs: []
      }
    default:
      return state
  }
}

export default additionalServiceReducer
